/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

export enum videoStates {
  LOADING,
  WATCH,
  FORBIDDEN, // must purchase
  FORBIDDEN_TEAM, // must update team selection
  FORBIDDEN_CLIP,
}
